<section id="about">
    <div class="container">
        <h2><strong>{{'about.title' | translate}}</strong></h2>
        <span class="bar-title mb-5"></span>
        <div class="row">
            <div class="col-lg-4 col-md-12" data-aos="fade-right">
                <picture>
                    <img src="assets/images/profile.jpg" alt="photo de profil" class="img-fluid">
                </picture>
                <div class="d-flex justify-content-center">
                    <a class="btn-social-media" href="https://www.linkedin.com/in/abdul-rehman-1cs15" rel="tooltip"
                        target="_blank" title="{{'about.followMeOn' | translate}} Linkedin">
                        <i class="fa fa-linkedin fa-lg "></i>
                    </a>
                    <a class="btn-social-media btn-default btn-round btn-lg btn-icon"
                        href="https://github.com/AbdulRehman-Ravian" rel="tooltip" target="_blank"
                        title="{{'about.followMeOn' | translate}} GitHub">
                        <i class="fa fa-github fa-lg "></i></a>
                </div>
            </div>
            <div class="col-lg-8  col-md-12 pt-4 pt-lg-0" data-aos="fade-left">
                <h3>Full Stack Developer</h3>

                <p class="font-italic">
                    {{'about.introductionOfMe' | translate}}
                    <br>{{'about.passionateAboutDevelopment' | translate}} <b>Back-End</b> {{'about.and' | translate}}
                    <b>Front-End</b>.
                </p>
                <div class="row">
                    <div class="col-lg-6 col-md-6">
                        <ul>
                            <li>
                                <fa-icon [icon]="mapMarker"></fa-icon>
                                <strong>Pakistan</strong>
                            </li>
                            <li>
                                <fa-icon [icon]="building"></fa-icon><strong> Lahore, Pakistan</strong>
                            </li>
                            <li>
                                <fa-icon [icon]="email"></fa-icon><strong><a href="a.rehman1cs15@gmail.com">
                                        a.rehman1cs15@gmail.com</a></strong>
                            </li>
                        </ul>
                    </div>
                    <div class="col-lg-6 col-md-6">
                        <ul>
                            <li>
                                <fa-icon [icon]="birthday"></fa-icon>
                                <strong> 25 Years</strong>
                            </li>
                            <li>
                                <fa-icon [icon]="badge"></fa-icon>
                                <strong>Bachelors in Computer Science</strong>
                            </li>
                            <li>
                                <fa-icon [icon]="mobile"></fa-icon>
                                <strong>+92 309 7797609</strong>
                            </li>
                        </ul>
                    </div>
                </div>
                <p>
                    {{'about.researchDescription' | translate}}
                </p>
            </div>
        </div>
    </div>
</section>